import { render, staticRenderFns } from "./InPageNavigation.vue?vue&type=template&id=2f2af1bb&scoped=true&"
import script from "./InPageNavigation.vue?vue&type=script&lang=ts&"
export * from "./InPageNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./InPageNavigation.vue?vue&type=style&index=0&id=2f2af1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2af1bb",
  null
  
)

export default component.exports